const TokenKey = 'Admin-Token'

const ExpiresInKey = 'Admin-Expires-In'

const Codes = 'Admin-Codes'

export function getToken() {
  var token = sessionStorage.getItem(TokenKey);
  if (token) {
    return sessionStorage.getItem(TokenKey);
  }else{
      token = getQueryVariable("token");
    if(token){
      sessionStorage.setItem(TokenKey, token);
    }
    return token;
  }
  // return sessionStorage.getItem(TokenKey)
}

export function setToken(token) {
  return sessionStorage.setItem(TokenKey, token)
}

export function removeToken() {
  return sessionStorage.removeItem(TokenKey)
}

export function getExpiresIn() {
  return sessionStorage.getItem(ExpiresInKey) || -1
}

export function setExpiresIn(time) {
  return sessionStorage.setItem(ExpiresInKey, time)
}

export function removeExpiresIn() {
  return sessionStorage.removeItem(ExpiresInKey)
}

export function getCodeList() {
  return sessionStorage.getItem(Codes)
}

export function setCodeList(code) {
  return sessionStorage.setItem(Codes, code)
}
function getQueryVariable(variable)
{
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i=0;i<vars.length;i++) {
    var pair = vars[i].split("=");
    if(pair[0] == variable){return pair[1];}
  }
  return null;
}
